export const BULK_MESSAGE_LIMIT = 4096;

/** Parsed-text rules: intelligent-support-backend#621, Bulk API contract.
 * The backend remains authoritative for markup validation and delivery.
 */
export const getBulkMessageContent = (html = '') => {
  const document = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
  const readText = (node: Node): string => {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent ?? '';
    }
    if (node.nodeName === 'BR') {
      return '\n';
    }
    return Array.from(node.childNodes).map(readText).join('');
  };

  // DOM parsing decodes entities exactly once. Normalize after decoding, too,
  // so encoded CR/CRLF follows the same rules as literal line endings.
  const text = readText(document.body).replace(/\r\n?/g, '\n');
  return { text, length: Array.from(text).length, hasText: text.trim().length > 0 };
};
